import React from "react";
import {Colors, Text} from "../../../ui";

export type ErrorOrigin = "external" | "internal" | "bounce" | "partner";

export type SuccessPayment = {success: true; error_message: null};
export type FailedPayment = {
  success: false;
  error_message: string;
  error_reason: string;
  error_explanation: string;
  error_origin?: ErrorOrigin;
  error_code?: string;
};

export type IResponseData = SuccessPayment | FailedPayment;

export class PaymentError extends Error {
  reason: string;
  explanation: string;
  origin?: ErrorOrigin;
  code?: string;

  constructor(
    message: string,
    error_reason: string,
    error_explanation: string,
    error_origin?: ErrorOrigin,
    error_code?: string
  ) {
    super(message);
    this.reason = error_reason;
    this.explanation = error_explanation;
    this.origin = error_origin;
    this.code = error_code;
  }
}

interface PaymentContextProps {
  buttonTouched: boolean;
  setButtonTouched: (value: boolean) => void;
  isLoading?: boolean;
  showOneCentLabel?: boolean;
  showLargeSplitLabel?: boolean;
  disableButton?: boolean;
  disableACHAccountOwnerPrePopulation?: boolean;
}

export const PaymentContext = React.createContext<PaymentContextProps>(undefined!);

const getAmountValidationMessage = (amount: number, totalBalance: number) => {
  if (amount < 0) return "Invalid amount";
  if (amount > totalBalance) return "Insert a lower amount";
  return "Insert a higher amount";
};

const getAmountValidationHelperText = ({
  isValid,
  amount,
  totalBalance,
}: {
  isValid: boolean;
  amount?: number;
  totalBalance: number;
}) => {
  if (amount === 0 || isValid) {
    return;
  }
  if (!isValid && amount && amount !== 0) {
    return (
      <Text size={12} variant={"interDisplay400"} sx={{color: Colors.red._900}}>
        {getAmountValidationMessage(amount, totalBalance)}
      </Text>
    );
  }
};

export {getAmountValidationHelperText};
